import { useQuery } from '@tanstack/react-query'

import { QUERY_KEY_AUTO_BOOKINGS_QUEUE_SIZE } from '@/types/constants'
import { authenticatedApi } from '@/utils/api'

async function getAutoBookingsQueueSize() {
  return authenticatedApi.get(`customer/auto_bookings_queue_size`).json<{ size: number }>()
}

export const useAutoBookingsQueueSize = (enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEY_AUTO_BOOKINGS_QUEUE_SIZE],
    queryFn: () => getAutoBookingsQueueSize(),
    enabled,
  })
}
